import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { classNames, Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { Avatar } from "../Avatar";
export function CurrencyItemChainBadge(t0) {
  const $ = _c(34);
  const {
    identifier,
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const t = useTranslations("wallet.CurrencyItemChainBadge");
  const {
    getLogo,
    getName
  } = useChains();
  let T0;
  let props;
  let t2;
  if ($[0] !== getLogo || $[1] !== getName || $[2] !== identifier || $[3] !== t) {
    const name = getName(identifier);
    let t3;
    if ($[7] !== getLogo || $[8] !== identifier) {
      t3 = getLogo(identifier, {
        square: true
      });
      $[7] = getLogo;
      $[8] = identifier;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    const logo = t3;
    let t4;
    if ($[10] !== getName || $[11] !== identifier) {
      t4 = getName(identifier);
      $[10] = getName;
      $[11] = identifier;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    const t5 = "src" in logo && "size-full";
    let t6;
    if ($[13] !== t5) {
      t6 = classNames("text-white", t5);
      $[13] = t5;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] !== logo) {
      t7 = "icon" in logo && {
        overrides: {
          Icon: {
            size: "100%"
          }
        }
      };
      $[15] = logo;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    let t8;
    if ($[17] !== logo || $[18] !== t4 || $[19] !== t6 || $[20] !== t7) {
      t8 = {
        ...logo,
        title: t4,
        className: t6,
        ...t7
      };
      $[17] = logo;
      $[18] = t4;
      $[19] = t6;
      $[20] = t7;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    props = t8;
    T0 = Tooltip;
    t2 = t("chain", {
      name
    });
    $[0] = getLogo;
    $[1] = getName;
    $[2] = identifier;
    $[3] = t;
    $[4] = T0;
    $[5] = props;
    $[6] = t2;
  } else {
    T0 = $[4];
    props = $[5];
    t2 = $[6];
  }
  let t3;
  if ($[22] !== className) {
    t3 = classNames("bg-black p-0", className);
    $[22] = className;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== props) {
    t4 = <Avatar {...props} />;
    $[24] = props;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  let t5;
  if ($[26] !== size || $[27] !== t3 || $[28] !== t4) {
    t5 = <Avatar.Badge className={t3} size={size}>{t4}</Avatar.Badge>;
    $[26] = size;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[30] !== T0 || $[31] !== t2 || $[32] !== t5) {
    t6 = <T0 content={t2}>{t5}</T0>;
    $[30] = T0;
    $[31] = t2;
    $[32] = t5;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  return t6;
}